import styled, { themeGet } from "@styled";

export const StyledSection = styled.section`
    padding-block-start: 59px;
    padding-block-end: 29px;
    background: ${themeGet("colors.primary")};
`;
